export default __webpack_public_path__ + "static/media/storageUnit1-beforeA.8fbe8498.jpg";